module.exports = __webpack_public_path__ + "static/media/03-print-ad.5f0ed3a0.png";